var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgReferralGreenCheckmark = function SvgReferralGreenCheckmark(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "207px",
    height: "166px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -498 -26 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 206.09066742081447 16.12291666666667  L 191.28376696832578 0.31458333333333144  L 66.48274886877827 133.55625  L 15.716233031674209 79.35624999999999  L 0.9093325791855186 95.72916666666664  L 66.48274886877827 165.17291666666665  L 206.09066742081447 16.12291666666667  Z ",
    fillRule: "nonzero",
    fill: "#226212",
    stroke: "none",
    transform: "matrix(1 0 0 1 498 26 )"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReferralGreenCheckmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/referral_green_checkmark.5ada1e6bbb2a8b5d1dedce989181d32d.svg";